export default {"src":"/_next/static/media/GradientLavender.e5a82887.svg","height":198,"width":1148,"blurWidth":0,"blurHeight":0};